import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Configuration } from './models/configuration.model';

@Injectable({ providedIn: 'root' })
export class ConfigurationService {
  public configuration = {} as Configuration;

  constructor() {}

  loadConfig(http: HttpClient): Observable<void> {
    return http.get<Configuration>('config.json').pipe(
      map((config) => {
        this.configuration = config;
      }),
      catchError((err) => {
        console.error('Could not load config.json', err);
        return of(void 0);
      }),
    );
  }
}
